import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=123e86a7&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=123e86a7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123e86a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123e86a7')) {
      api.createRecord('123e86a7', component.options)
    } else {
      api.reload('123e86a7', component.options)
    }
    module.hot.accept("./userInfo.vue?vue&type=template&id=123e86a7&scoped=true", function () {
      api.rerender('123e86a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/user/components/userInfo.vue"
export default component.exports